"use strict";

var _classCallCheck = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address = void 0;

var assert_1 = __importDefault(require("assert"));

var bn_js_1 = __importDefault(require("bn.js"));

var bytes_1 = require("./bytes");

var account_1 = require("./account");

var Address = /*#__PURE__*/function () {
  function Address(buf) {
    _classCallCheck(this, Address);

    assert_1.default(buf.length === 20, 'Invalid address length');
    this.buf = buf;
  }
  /**
   * Returns the zero address.
   */


  _createClass(Address, [{
    key: "equals",
    value:
    /**
     * Is address equal to another.
     */
    function equals(address) {
      return this.buf.equals(address.buf);
    }
    /**
     * Is address zero.
     */

  }, {
    key: "isZero",
    value: function isZero() {
      return this.equals(Address.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */

  }, {
    key: "isPrecompileOrSystemAddress",
    value: function isPrecompileOrSystemAddress() {
      var addressBN = new bn_js_1.default(this.buf);
      var rangeMin = new bn_js_1.default(0);
      var rangeMax = new bn_js_1.default('ffff', 'hex');
      return addressBN.gte(rangeMin) && addressBN.lte(rangeMax);
    }
    /**
     * Returns hex encoding of address.
     */

  }, {
    key: "toString",
    value: function toString() {
      return '0x' + this.buf.toString('hex');
    }
    /**
     * Returns Buffer representation of address.
     */

  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return Buffer.from(this.buf);
    }
  }], [{
    key: "zero",
    value: function zero() {
      return new Address(bytes_1.zeros(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */

  }, {
    key: "fromString",
    value: function fromString(str) {
      assert_1.default(account_1.isValidAddress(str), 'Invalid address');
      return new Address(bytes_1.toBuffer(str));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */

  }, {
    key: "fromPublicKey",
    value: function fromPublicKey(pubKey) {
      assert_1.default(Buffer.isBuffer(pubKey), 'Public key should be Buffer');
      var buf = account_1.pubToAddress(pubKey);
      return new Address(buf);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */

  }, {
    key: "fromPrivateKey",
    value: function fromPrivateKey(privateKey) {
      assert_1.default(Buffer.isBuffer(privateKey), 'Private key should be Buffer');
      var buf = account_1.privateToAddress(privateKey);
      return new Address(buf);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */

  }, {
    key: "generate",
    value: function generate(from, nonce) {
      assert_1.default(bn_js_1.default.isBN(nonce));
      return new Address(account_1.generateAddress(from.buf, nonce.toArrayLike(Buffer)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */

  }, {
    key: "generate2",
    value: function generate2(from, salt, initCode) {
      assert_1.default(Buffer.isBuffer(salt));
      assert_1.default(Buffer.isBuffer(initCode));
      return new Address(account_1.generateAddress2(from.buf, salt, initCode));
    }
  }]);

  return Address;
}();

exports.Address = Address;